// import CombinedStudyStore from 'app/adapters/CombinedStudyStore';
import { WMStudyStore } from 'app/dicom/WorklistMonitor';
import { StudyStore } from 'app/interfaces/StudyStore';
import React from 'react';

const StudyStoreContext = React.createContext<StudyStore & WMStudyStore>(undefined);
export default StudyStoreContext;
